import { createRouter, createWebHistory } from 'vue-router';
import { ElMessage } from 'element-plus';
import ConfirmPage from '@/pages/ExamineePage/components/ExamineeConfirmPage/ConfirmPage.vue';
import ExamPage from '@/pages/ExamineePage/components/ExamPage/ExamPage.vue';
import ExamineeLogin from '@/pages/ExamineePage/ExamineeLogin.vue';
import ExamineeHome from '@/pages/ExamineePage/ExamineeHome.vue';

// 路由配置
// requiresAuth: true 表示需要登录
// requiresAdmin: true 表示需要管理员权限

const routes = [
  {
    path: '/',
    redirect: '/student-login'
  },
  {
    path: '/student-login',
    name: 'ExamineeLogin',
    component: ExamineeLogin,
    meta: {
      title: '考生登录'
    }
  },
  {
    path: '/confirmPage',
    name: 'confirmPage',
    component: ConfirmPage,
    meta: {
      title: '考生信息确认',
      requiresAuth: true // 需要登录
    }
  },
  {
    path: '/examPage',
    name: 'ExamPage',
    component: ExamPage,
    meta: {
      title: '考试',
      requiresAuth: true // 需要登录
    }
  },
  {
    path: '/examinee-home',
    name: 'ExamineeHome',
    component: ExamineeHome,
    meta: {
      title: '考生主页',
      requiresAuth: true // 需要登录
    }
  },
  {
    path: '/:pathMatch(.*)*', // 匹配所有未定义的路由
    redirect: '/student-login'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

function checkAdminAuth(to, next) {
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const isAdmin = userInfo ? userInfo.isAdmin : false;
    if (!isAdmin) {
      next({ path: '/admin-login' });
    } else {
      next();
    }
  } else {
    next();
  }
}

router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title || '默认标题';
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const token = userInfo ? userInfo.token : null;

  // 如果用户已经登录，且目标路由是登录页面，跳转到主页或其他页面
  if (token && (to.name === 'ExamineeLogin')) {
      next({ path: '/examinee-home'});
    return;
  }

  // 检查是否需要登录
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({ path: '/' });
    } else {
      // 检查 token 是否过期
      const tokenExpiration = userInfo ? userInfo.tokenExpiration : null;
      const now = new Date().getTime();
      if (tokenExpiration && now > tokenExpiration) {
        ElMessage.warning('Token 已过期, 请重新登录'); 
        localStorage.clear();
        next({ path: '/' });
      } else {
        checkAdminAuth(to, next);
      }
    }
  } else {
    next();
  }
});

export default router;
